"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));

var _react = _interopRequireDefault(require("react"));

var _router = require("@reach/router");

var _gatsby = require("gatsby");

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _antd = require("antd");

var _icons = require("@ant-design/icons");

var _auth = require("../utils/auth");

var _routes = _interopRequireDefault(require("../routes"));

var _templateObject;

var AvatarMenu = function AvatarMenu(props) {
  var ghost = props.ghost;

  var handleSignOut = function handleSignOut() {
    return (0, _auth.logout)(function () {
      return (0, _gatsby.navigate)('/');
    });
  };

  var dropDownMenu = /*#__PURE__*/_react.default.createElement(StyledMenu, null, /*#__PURE__*/_react.default.createElement(_antd.Menu.Item, null, /*#__PURE__*/_react.default.createElement(_router.Link, {
    to: (0, _routes.default)('profile')
  }, "Profile")), /*#__PURE__*/_react.default.createElement(_antd.Menu.Item, {
    onClick: handleSignOut
  }, "Logout"));

  return /*#__PURE__*/_react.default.createElement(_antd.Dropdown, {
    overlay: dropDownMenu,
    arrow: true,
    trigger: ['click']
  }, /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(_antd.Button, {
    size: 'middle',
    icon: /*#__PURE__*/_react.default.createElement(_icons.UserOutlined, null),
    ghost: ghost
  })));
};

var StyledMenu = (0, _styledComponents.default)(_antd.Menu)(_templateObject || (_templateObject = (0, _taggedTemplateLiteral2.default)(["\n  width: 150px;\n"])));
var _default = AvatarMenu;
exports.default = _default;